import {
    physician,
    getAllHospitalByPhysician,
    getAllDept,
    uploadOrgBegin,
    uploadOrgDone,
    downloadResultResource,
    getAllLog,
    addCaseLog,
    exportCustomCaseLog, imagingEngineer,
    // getAllHospital
} from '../../../service/service'
import axios from 'axios'
export default {
    name:'custom',
    data: function() {
        return {
            data2: [
                {
                    title: 'parent 1',
                    expand: true,
                    children: [
                        {
                            title: 'parent 1-1',
                            expand: true
                        },
                        {
                            title: 'parent 1-2',
                            expand: true
                        }
                    ]
                }
            ],
            total: 0,
            patientName:'',
            dateOfSurgery: ['',''],
            keywordSearch: '',
            columns1: [
                {
                    title: this.$t('Case ID'),
                    key: 'id',tooltip:true
                },{
                    title: this.$t('patient name'),
                    key: 'patientname',tooltip:true
                },{
                    title: this.$t('hospital'),
                    minWidth: 100,
                    key: 'hospitalName',tooltip:true
                },{
                    title: this.$t('date of surgery'),
                    key: 'dateofsurgery',tooltip:true
                },{
                    title: this.$t('priority'),
                    slot: 'priority',tooltip:true
                },{
                    title: this.$t('status'),
                    key: 'status',tooltip:true
                },{
                    title: this.$t('surgical plan'),
                    slot: 'action',tooltip:true
                },{
                    title: this.$t('add note'),
                    slot: 'action2',tooltip:true
                },
                {
                    title: this.$t('more info'),
                    slot: 'more'
                }
            ],
            data1: [],
            modal: false,
            txtComment: '',
            formItem: {
                physician: '',
                specialty: '',
                patientname: '',
                hospital: '',
                dateofsurgery: '',
                priority: false,
                representative:''
            },
            formItem2: {
                physician: '',
                specialty: '',
                patientname: '',
                hospital: '',
                dateofsurgery: '',
                priority: false,
                representative:''
            },
            note:'',
            ruleInline: {
                physician:[
                    { required: true, message: this.$t('Please select the hospital'), trigger: 'change' }
                ],
                representative:[
                    { required: true, message: this.$t('Please select the hospital'), trigger: 'change' }
                ],
                patientname: [
                    { required: true, message: this.$t('Please fill in the patient name'), trigger: 'blur' }
                ],
                hospital: [
                    { required: true, message: this.$t('Please select the hospital'), trigger: 'change' }
                ],
                priority:[
                    { required: true, message: this.$t('Please select at priority'), trigger: 'change', type: 'boolean' }
                ]
            },
            modalNext: false,
            fileList: [],
            options: {
                target: axios.defaults.baseURL + 'api/common/uploadOrg',
                testChunks: false,
                // autoStart: false,
                chunkSize: 1024*1024*2,  //1MB
                simultaneousUploads: 1, //并发上传数
                fileParameterName: 'param',
                query:{
                    caseId: ""
                }
            },
            showConfirmation:false,
            single:false,
            modal3:false,
            modal2:false,
            commentList:[1,1,1,1,1],
            modal1:false,
            modal6:false,
            showModifyModal:false,
            pagesize:20,
            pageTo:"1",
            page: 1,
            showBackBtn:true,
            arrTree:[],
            tempTree:[],
            tid: '',
            expeditedTotal: 0,
            dataInfo:null,
            userName:'',
            hospitalList: [],
            isUpload: false,
            confirmSalesRep:'',
            confirmPhysician:'',
            confirmHospital:'',
            CaseSalename:'',
            chooseRow:[{'caseId':'caseId'}],
            modal7: false,
            tipsCount:'',
            noticStatus: false,
            searchMark:false,
            timeoutId:''
        }
    },
    methods: {
        // 导出表格
        toCsv(){
            console.log(JSON.stringify(this.chooseRow))
            exportCustomCaseLog({
                "userId":this.token,
                "patientName": this.patientName,
                "startDateOfSurgery": this.dateOfSurgery[0],
                "endDateOfSurgery": this.dateOfSurgery[1],
                "keywordSearch": this.keywordSearch,
                "physicianList": JSON.stringify(this.arrTree)
            })
        },
        // 选取表格高亮行
        rowClass(row){
            if(row._isHighlight){
                // console.log(row)
                return "row-class"
            }
        },
        onSelectRow(row, index){
            // console.log(this.$refs.tableJin.objData[index])
            // console.log(selection)
            if(!this.$refs.tableJin.objData[index]._isHighlight){
                this.$refs.tableJin.objData[index]._isHighlight = true
                let obj = {
                    caseId: row.id
                }
                this.chooseRow.push(obj)
            }else{
                this.chooseRow.forEach((e,i)=>{
                    if(row.id === e.id){
                        this.chooseRow.splice(i,1)
                    }
                })
                this.$refs.tableJin.objData[index]._isHighlight = false
            }
        },
        reloadView(){
            let obj = {
                userId: this.token,
                "page": this.page,
                "limit": this.pagesize,
                "patientName": this.patientName,
                "startDateOfSurgery": this.dateOfSurgery[0],
                "endDateOfSurgery": this.dateOfSurgery[1],
                "keywordSearch": this.keywordSearch
            }
            if(this.arrTree.length){
                obj["physicianList"] = JSON.stringify(this.arrTree)
            }
            physician.custom.getCustomData(obj).then(res=>{
                let code = parseInt(res.code)
                this.searchMark = false;
                this.timeoutId = 0;
                this.$Spin.hide();
                if(!code){
                    let data = JSON.parse(res.data)
                    if(data.list){
                        this.data1 = JSON.parse(data.list)
                        console.log(this.data1)
                    }else{
                        this.data1 = []
                    }
                    // console.log(JSON.parse(data.list))
                    this.total = data.totalAll
                    this.expeditedTotal = data.totalExpedited
                    this.$refs.elScrol.wrap.scrollTop = 0
                    this.$refs.elScrol.wrap.scrollLeft = 0
                }else{
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        changePatientName(){
            this.page = 1
            this.pageTo = 1
            var that = this;
            if (this.searchMark) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    that.reloadView();
                }, 1000);
            } else {
                this.timeoutId = setTimeout(function () {
                    that.reloadView();
                }, 1000);
                this.searchMark = true;
            }
        },
        goPage(){
            if(this.pageTo){
                let maxPage = Math.ceil(parseInt(this.total) / parseInt(this.pagesize))
                if(parseInt(this.pageTo) > maxPage){
                    this.page = maxPage
                }else{
                    this.page = parseInt(this.pageTo)
                }
                this.pageTo = this.page
                this.reloadView()
            }else{
                this.pageTo = this.page
            }
        },
        changePage(e){
            // console.log(e)
            this.page = e
            this.pageTo = e
            this.reloadView()
        },
        changePageSize(size){
            this.pagesize = size
        },
        ok7(){
            this.modal6 = false
            this.modal = false
            this.modal7 = false
            this.showModifyModal = false
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color:'#f48221',
                                size: 18
                            }
                        }),
                        h('div',{
                            style: {
                                color: '#f48221'
                            },
                        } ,'Loading')
                    ])
                }
            });
            physician.custom.getCustomInfo({
                id: this.tid
            }).then(res=>{
                let code = parseInt(res.code)
                if(!code){
                    this.dataInfo = JSON.parse(res.data)
                    console.log(this.dataInfo)
                }else{
                    this.$Message.warning(this.$t('fail'))
                }
                getAllLog({
                    userId:this.token,
                    caseId: this.tid
                }).then(res=>{
                    let code = parseInt(res.code)
                    this.$Spin.hide();
                    console.log(JSON.parse(res.data))
                    let logList = []
                    JSON.parse(res.data).forEach(i=>{
                        logList.push(JSON.parse(i))
                    })
                    console.log(logList)
                    if(!code){
                        this.commentList = logList
                    }
                    this.modal2 = true
                })
            })
            this.reloadView()
        },
        ok6(){
            if(this.txtComment.length > 60000){
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            let userName = sessionStorage.getItem('userName')
            let obj = {
                id: this.tid,
                count: this.txtComment,
                userid: this.token,
                currentUserName: userName
            }
            physician.custom.customRequestCancellation(obj).then(res=>{
                console.log(res)
                if(res.code === '0'){
                    this.modal7 = true
                    addCaseLog({
                        userId:this.token,
                        caseId:this.tid,
                        logType:'Case Cancelled',
                        remarks:this.txtComment
                    }).then(res=>{
                        console.log(res)
                        this.txtComment = ''
                    })
                }else if(res.code === '-100'){
                    this.$Message.error('No permission to perform this operation.')
                }else{
                    this.$Message.warning(this.$t('fail'))
                }
            })
            this.modal6 = false
        },
        cancel6(){
            this.modal6 = false
        },
        requestCancellation(){
            this.modal6 = true
        },
        ok5(){
            if(this.note.length > 60000){
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            let p = {
                "userId": this.token,
                "id": this.tid,
                "salesRepresentative": this.dataInfo.SalesId,
                "physician": this.dataInfo.DocId,
                "patientName": this.formItem2.patientname,
                "hospital": this.formItem2.hospital,
                "dateOfSurgery": this.formItem2.dateofsurgery,
                "notes": this.note
                // "flieList": JSON.stringify(this.fileList)
            }
            if(this.dataInfo.CaseUrgent === 'expedited'){
                p.priority = 'Expedited'
            }else{
                p.priority = 'Standard'
            }
            physician.custom.editCustomInfo(p).then(res=>{
                if(res.code === '0'){
                    this.modal = false
                    this.modalNext = false
                    this.note = ''
                    this.formItem2.physician = ''
                    this.formItem2.specialty = ''
                    this.formItem2.patientname = ''
                    this.formItem2.hospital = ''
                    this.formItem2.dateofsurgery = ''
                    this.formItem2.priority = false
                    this.showConfirmation = false
                    this.modal3 = true
                    this.modal6 = false
                    // this.modal2 = false
                    physician.custom.getCustomInfo({
                        id: this.tid
                    }).then(res=>{
                        let code = parseInt(res.code)
                        if(!code){
                            this.dataInfo = JSON.parse(res.data)
                            console.log(this.dataInfo)
                        }else{
                            this.$Message.warning(this.$t('fail'))
                        }
                        getAllLog({
                            userId:this.token,
                            caseId: this.tid
                        }).then(res=>{
                            this.showModifyModal = false
                            let code = parseInt(res.code)
                            this.$Spin.hide();
                            console.log(JSON.parse(res.data))
                            let logList = []
                            JSON.parse(res.data).forEach(i=>{
                                logList.push(JSON.parse(i))
                            })
                            console.log(logList)
                            if(!code){
                                this.commentList = logList
                            }
                            this.modal2 = true
                        })
                    })
                }else if(res.code === '-100'){
                    this.$Message.error('No permission to perform this operation.')
                }else{
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        cancel5(){
            // this.modal2 = false
            this.showModifyModal = false
            this.formItem2.physician = ''
            this.formItem2.hospital = ''
            this.formItem2.patientname = ''
            this.formItem2.dateofsurgery = '',
            this.note = ''
        },
        showModify(){
            this.formItem2.physician = this.dataInfo.DocId
            console.log(this.hospitalList)
            // this.hospitalList.forEach(i=>{
            //     if(i.hospitalId === )
            // })
            this.formItem2.hospital = this.dataInfo.CaseHos
            this.formItem2.patientname = this.dataInfo.CasePatient
            this.formItem2.dateofsurgery = this.dataInfo.CaseSurgdate
            this.showModifyModal = true
            getAllHospitalByPhysician({
                userId: this.token,
                doctorId: this.token
            }).then(res=>{
                let code = parseInt(res.code)
                if(!code){
                    let hosList = JSON.parse(res.data)
                    console.log(hosList)
                    this.hospitalList2 = hosList
                }
            })
        },
        ok4(){
            if(this.txtComment.length > 60000){
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            // let obj = {
            //     "userId": this.token,
            //     "id": this.tid,
            //     "name": this.userName,
            //     "count": this.txtComment
            // }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color:'#f48221',
                                size: 18
                            }
                        }),
                        h('div',{
                            style: {
                                color: '#f48221'
                            },
                        } ,'Loading')
                    ])
                }
            });
            physician.custom.addCustomComment({
                userId:this.token,
                id:this.tid,
                count:this.txtComment
            }).then(res=>{
                console.log(res)
                let code = parseInt(res.code)
                if(!code){
                    this.modal1 = false
                    this.txtComment = ''
                    this.tname = ''
                    getAllLog({
                        userId:this.token,
                        caseId: this.tid
                    }).then(res=>{
                        let code = parseInt(res.code)
                        this.$Spin.hide();
                        console.log(JSON.parse(res.data))
                        let logList = []
                        JSON.parse(res.data).forEach(i=>{
                            logList.push(JSON.parse(i))
                        })
                        console.log(logList)
                        if(!code){
                            this.commentList = logList
                        }
                        if (this.showModifyModal){
                            this.modal2 = true
                        }
                    })
                }else{
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        cancel4(){
            this.modal1 = false
        },
        addComment(row,index){
            console.log(row,index)
            this.tid = row.id
            this.tname = row.name
            this.modal1 = true
        },
        addComment2(){
            this.modal1 = true
        },
        showDetail(row){
            this.tid = row.id
            this.tname = row.name
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color:'#f48221',
                                size: 18
                            }
                        }),
                        h('div',{
                            style: {
                                color: '#f48221'
                            },
                        } ,'Loading')
                    ])
                }
            });
            physician.custom.getCustomInfo({
                id: this.tid
            }).then(res=>{
                let code = parseInt(res.code)
                if(!code){
                    this.dataInfo = JSON.parse(res.data)
                    console.log(this.dataInfo)
                }else{
                    this.$Message.warning(this.$t('fail'))
                }
                // let p1 ={
                //     id: this.tid
                // }
                getAllLog({
                    userId:this.token,
                    caseId: this.tid
                }).then(res=>{
                    let code = parseInt(res.code)
                    this.$Spin.hide();
                    console.log(JSON.parse(res.data))
                    let logList = []
                    JSON.parse(res.data).forEach(i=>{
                        logList.push(JSON.parse(i))
                    })
                    console.log(logList)
                    if(!code){
                        this.commentList = logList
                    }
                    this.modal2 = true
                })
            })
        },
        ok3(){
            this.modal3 = false
            this.fileList = []
            this.modalNext = false
            this.reloadView()
        },
        fileAdded(file){
            console.log(file)
            // this.isUpload = false
            uploadOrgDone({caseId:this.options.query.caseId}).then(res=>{
                if(res.code === '0'){
                    this.$Spin.hide();
                    // this.modalNext = true
                    if(this.showModifyModal){
                        this.isUpload = false
                        addCaseLog({
                            userId:this.token,
                            caseId:this.tid,
                            logType:'Additional Data Uploaded',
                            remarks:''
                        }).then(res=>{
                            console.log(res)
                            if(this.noticStatus){
                                let userName = sessionStorage.getItem('userName')
                                physician.custom.uploadNewFileNotice({
                                    id:this.options.query.caseId,
                                    currentUserName:userName
                                }).then(()=>{
                                    this.noticStatus = false
                                })
                            }
                        })
                    }
                    this.modal = false
                    this.modalNext = false
                    this.note = ''
                    this.formItem.physician = ''
                    this.formItem.specialty = ''
                    this.formItem.patientname = ''
                    this.formItem.hospital = ''
                    this.formItem.dateofsurgery = ''
                    this.formItem.priority = false
                    this.showConfirmation = false
                    this.modal3 = true
                    this.modal6 = false
                }
            })
        },
        delFile(i){
            this.fileList.splice(i,1)
        },
        handleUpload(file){
            // this.isUpload = true
            // console.log(started)
            let arr = this.fileList;
            arr.push(file)
            this.fileList = arr
            return false;
        },
        back(){
            this.modalNext = false
        },
        handleSubmit (name) {
            if(this.note.length > 60000){
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            this.$refs[name].validate((valid) => {
                if (valid) {
                    // this.$Message.success('Success!');
                    this.modalNext = true
                } else {
                    this.$Message.error('Please ﬁx the error(s) indicated below.');
                }
            })
        },
        ok1(){
            if(this.note.length > 60000){
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            this.single  = false;
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color:'#f48221',
                                size: 18
                            }
                        }),
                        h('div',{
                            style: {
                                color: '#f48221'
                            },
                        } ,'Uploading')
                    ])
                }
            });
            let p ={
                // "salesRepresentative": this.userName,
                "userId": this.token,
                "physician": this.token,
                "patientName": this.formItem.patientname,
                "hospital": this.formItem.hospital,
                "dateOfSurgery": this.formItem.dateofsurgery,
                // "priority": this.formItem.priority,
                "notes": this.note,
                // "flieList": JSON.stringify(this.fileList)
            }
            // console.log(this.formItem.priority)
            if(this.formItem.priority){
                p.priority = 'Expedited'
            }else{
                p.priority = 'Standard'
            }
            physician.custom.addNewCase(p).then(res=>{
                console.log(res)
                let code = parseInt(res.code)
                if(!code){
                    addCaseLog({
                        userId:this.token,
                        caseId:this.tid,
                        logType:'Case Submitted',
                        remarks:this.note
                    }).then(res=>{
                        console.log(res)
                    })
                    this.options.query.caseId = res.caseId
                    physician.custom.getCustomInfo({
                        id: res.caseId
                    }).then(res=>{
                        let code = parseInt(res.code)
                        if(!code){
                            this.dataInfo = JSON.parse(res.data)
                            this.CaseSalename = this.dataInfo.CaseSalename
                        }
                        this.tipsCount = 'A new case has been created.'
                        uploadOrgBegin({caseId:this.options.query.caseId}).then(res=>{
                            if(res.code === '0'){
                                let uploaderInstance = this.$refs.uploader.uploader
                                uploaderInstance.resume()
                            }else{
                                this.$Message.warning(this.$t('fail'))
                            }
                        })
                    })
                }
            })
        },
        ok(){
            if(!this.showModifyModal){
                this.showConfirmation = true
                // const uploaderInstance = this.$refs.uploader.uploader
                // console.log(uploaderInstance.upload)
            }else{
                let uploaderInstance = this.$refs.uploader.uploader
                uploaderInstance.resume()
                this.$Spin.show({
                    render: (h) => {
                        return h('div', [
                            h('Icon', {
                                'class': 'demo-spin-icon-load',
                                props: {
                                    type: 'ios-loading',
                                    color:'#f48221',
                                    size: 18
                                }
                            }),
                            h('div',{
                                style: {
                                    color: '#f48221'
                                },
                            } ,'Uploading')
                        ])
                    }
                });
                this.isUpload = true
                // this.modal = false
            }
        },
        cancel1(){
          this.showConfirmation = false
        },
        onModalCancel(){
            if(!this.showModifyModal){
                this.formItem.physician = ''
                this.formItem.specialty = ''
                this.formItem.patientname = ''
                this.formItem.hospital = ''
                this.formItem.dateofsurgery = ''
                this.formItem.priority = false
            }
            if(this.modalNext){
                let uploaderInstance = this.$refs.uploader.uploader
                uploaderInstance.cancel()
            }
            this.fileList = []
            this.modal = false
            this.modalNext = false
        },
        cancel () {
            if(!this.showModifyModal){
                this.formItem.physician = ''
                this.formItem.specialty = ''
                this.formItem.patientname = ''
                this.formItem.hospital = ''
                this.formItem.dateofsurgery = ''
                this.formItem.priority = false
            }
            if(this.modalNext){
                let uploaderInstance = this.$refs.uploader.uploader
                uploaderInstance.cancel()
            }
            this.fileList = []
            this.modal = false
            this.modalNext = false
        },
        addCase2(){
            this.options.query.caseId = this.dataInfo.CaseId
            this.tipsCount = 'Additional DICOM files have been uploaded.'
            this.noticStatus = true
            // console.log(this.options.query.caseId)
            uploadOrgBegin({caseId:this.dataInfo.CaseId}).then(res=>{
                if(res.code === '0'){
                    // this.$Message.success('Success!');
                    this.showBackBtn = false
                    this.modalNext = true
                    this.modal = true
                }else{
                    this.$Message.warning(this.$t('fail'))
                }
                this.$Spin.hide();
            })
        },
        addCase(){
            this.modal = true
            this.showBackBtn = true
        },
        download(row){
            console.log(row)
            // this.$Spin.show();
            if (row.resultId === ''){
                this.$Message.error('The surgical plan is unavailable')
                return;
            } else {
                downloadResultResource({caseId:row.id})
            }
        },
        showDate(){
            this.page = 1
            this.pageTo = 1
            var that =this;
            if (this.searchMark){
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function(){
                    that.page = 1;
                    that.reloadView();
                },2000);
            } else {
                this.timeoutId = setTimeout(function(){
                    that.page = 1;
                    that.reloadView();
                },2000);
                this.searchMark  = true;
            }
        },
        dateChange2(e){
            this.formItem2.dateofsurgery = e
        },
        dateChange1(e){
            this.page = 1
            this.pageTo = 1
            this.formItem.dateofsurgery = e
        },
        dateChange(e){
            // console.log(e)
            this.page = 1
            this.pageTo = 1
            this.dateOfSurgery = e
            var that = this;
            if (this.searchMark) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    that.reloadView();
                }, 1000);
            } else {
                this.timeoutId = setTimeout(function () {
                    that.reloadView();
                }, 1000);
                this.searchMark = true;
            }
        },
        selectSales(e){
            this.confirmSalesRep = e.label
        },
        selectPhysician(e){
            this.confirmPhysician = e.label
            getAllHospitalByPhysician({userId: this.token,doctorId: e.value}).then(res=>{
                let code = parseInt(res.code)
                if(!code){
                    let hosList = JSON.parse(res.data)
                    console.log(hosList)
                    this.hospitalList = hosList
                }
            })
        },
        selectHospital(e){
            this.confirmHospital = e.label
        }
    },
    created(){

    },
    mounted(){
        this.token = sessionStorage.getItem('token') || sessionStorage.getItem('token')
        // console.log(token)
        // this.userName =
        getAllDept({UserUID: this.token}).then(res=>{
            this.specialtylList = res.Dept
        })
        getAllHospitalByPhysician({userId: this.token,doctorId: this.token}).then(res=>{
            let code = parseInt(res.code)
            if(!code){
                let hosList = JSON.parse(res.data)
                console.log(hosList)
                this.hospitalList = hosList
            }
        })
        this.arrTree = [
            {physicianID: this.token}
        ]
        // let arr = []
        // getAllSalesReps({UserUID: this.token}).then(res=>{
        //     console.log(res.SalesReps)
        //     this.salesRepresentativeList = res.SalesReps
        //     res.SalesReps.forEach(i=>{
        //       let obj = {
        //         title: i.SalesName,
        //         expand: true,
        //         children: []
        //       }
        //       getAllPhysician({UserUID: this.token}).then(res=>{
        //         //   console.log(res)
        //         this.physiciansList = res.Physician
        //           res.Physician.forEach(j=>{
        //             if(j.SalesId === i.SalesId){
        //                 let opj1 = {
        //                     id: j.DocId,
        //                     title: j.DocName,
        //                     expand: true
        //                 }
        //                 obj.children.push(opj1)
        //             }
        //           })
        //       })
        //       arr.push(obj)
        //       this.data2 = arr
        //     })
        //   })
        this.$Spin.show({
            render: (h) => {
                return h('div', [
                    h('Icon', {
                        'class': 'demo-spin-icon-load',
                        props: {
                            type: 'ios-loading',
                            color:'#f48221',
                            size: 18
                        }
                    }),
                    h('div',{
                        style: {
                            color: '#f48221'
                        },
                    } ,'Loading')
                ])
            }
        });
        // eslint-disable-next-line no-irregular-whitespace
        let h = document.body.clientWidth
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal-details').forEach(i=>{
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom=h/1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal').forEach(i=>{
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom=h/1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal-case').forEach(i=>{
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom=h/1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal2').forEach(i=>{
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom=h/1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal1').forEach(i=>{
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom=h/1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        window.onresize = function(){
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal').forEach(i=>{
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom=h/1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            // console.log(h/1920 * 100 + '%')
            document.querySelectorAll('.custom-modal-details').forEach(i=>{
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom=h/1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal-case').forEach(i=>{
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom=h/1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal2').forEach(i=>{
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom=h/1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal1').forEach(i=>{
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom=h/1920 * 100 + '%'
            })
        }
        this.userName = sessionStorage.getItem('userName')
        this.reloadView()
    }
  }
